import { _,Marionette } from '../../vendor'
import { appRollingLoaderAnim } from '../views/AppAnnouncements'

/**
 * Adds a clickable "Load more" button at the end of a CollectionViewList
 * Note that we have to use btn.style.display instead of btn.classList.add/remove('hide')
 * because of duplications in InboomaBaseCollectionView (marked there as @todo)
 */

export default Marionette.Behavior.extend({

    _btn: null,
    _btnSelector: '#inb-c-main .off-canvas-wrapper .inb-next-page-button',

    collectionEvents : {
        'reset' : '_toggleBtnVisibility',
        'update' : '_toggleBtnVisibility'
    },

    _toggleBtnVisibility () {

        const btn = this._btn,
              collection = this.collection;

        setTimeout(() => {

            if (btn === null) return;

            if (collection.url == '/users')  return; // Because of two view types its always filtered

            // In the next tick, collection._pagination.has_next_page will be set properly
            if (!collection._pagination.has_next_page) {
                btn.style.display = 'none';
            } else {
                btn.style.display = 'block';
            }

        }, 0);
    },

    onRender () {

        if (document.querySelector(this._btnSelector)) {
            // Btn already rendered; skip
            return;
        }

        const that = this;

        this.collection = typeof this.view.collection._superset !== 'undefined'
                        ? this.view.collection._superset 
                        : this.view.collection;

        if (!this._btn) {
            // Create and append "show more" button

            const btn = document.createElement('a');

            btn.setAttribute('href','#');
            btn.setAttribute('title', this.view.t('load_more_title'));
            btn.classList.add('inb-next-page-button');
            btn.classList.add('button');
            btn.innerText = this.view.t('load_more');

            btn.addEventListener('click', () => {
                btn.innerHTML = appRollingLoaderAnim;

                that.collection.fetchNextPage(() => {
                    btn.innerText = that.view.t('load_more');
                });
            });

            const target = document.querySelector('#inb-c-main .off-canvas-wrapper');

            if (target) {
                target.insertAdjacentElement('beforeend', btn);

                this._btn = btn;
            }

        }

        this._toggleBtnVisibility();
    }
});
